// Tiers of the ebook. Topics live in ./topics/<tier>/<NN-slug>.js and are listed in ./topics/index.js.
export const TIERS = [
  { id: 'newbie', title: 'Newbie Trader', sub: 'Forex & gold basics for beginners', icon: '/tiers/newbie.png' },
  { id: 'amateur', title: 'Amateur Trader', sub: 'Strategy, analysis & risk management', icon: '/tiers/amateur.png' },
  { id: 'veteran', title: 'Veteran Trader', sub: 'Advanced techniques & psychology', icon: '/tiers/veteran.png' },
];
import ALL from './topics/index.js';
export const TOPICS = ALL.map(([tier, file, m]) => ({ id: `${tier}/${file}`, tier, order: parseInt(file, 10) || 0, ...m }))
.sort((a, b) => a.order - b.order);
export const topicsOf = tier => TOPICS.filter(t => t.tier === tier);
